import SocketioService from '@/services/socketioService';

export const addEventListener = {
  methods: {
    addEventListener(eventType, eventCallback) {
      SocketioService.addEventListener({
        type: eventType,
        callback: eventCallback
      });
    }
  }
};

export const removeEventListener = {
  methods: {
    removeEventListener(eventType, eventCallback) {
      SocketioService.removeEventListener({
        type: eventType,
        callback: eventCallback
      });
    }
  }
};